export default __webpack_public_path__ + "static/media/SAICE-Bookshop.a683cd14.png";